import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavBar, { NavBarItem } from "../../../components/NavBar";
import "./PrototypeShared.css";

interface Embarque {
  referencia: string;
  cliente: string;
  origem: string;
  modal: "Aéreo" | "Marítimo";
  diasEmAndamento: number;
  leadTimeEsperado: number;
  risco: "alto" | "medio" | "ok";
}

const embarques: Embarque[] = [
  { referencia: "REL-20819", cliente: "GE Celma Matriz", origem: "Cincinatti (CVG)", modal: "Aéreo", diasEmAndamento: 14, leadTimeEsperado: 8, risco: "alto" },
  { referencia: "REL-20824", cliente: "Baker Hughes", origem: "Dallas (DFW)", modal: "Aéreo", diasEmAndamento: 11, leadTimeEsperado: 8, risco: "alto" },
  { referencia: "REL-20831", cliente: "Motoman", origem: "Los Angeles (LAX)", modal: "Aéreo", diasEmAndamento: 9, leadTimeEsperado: 8, risco: "medio" },
  { referencia: "REL-20840", cliente: "GE Power & Water", origem: "Miami (MIA)", modal: "Aéreo", diasEmAndamento: 7, leadTimeEsperado: 8, risco: "ok" },
  { referencia: "REL-20847", cliente: "GE Celma Matriz", origem: "Chicago (ORD)", modal: "Aéreo", diasEmAndamento: 6, leadTimeEsperado: 8, risco: "ok" },
];

const riscoPill: Record<Embarque["risco"], { texto: string; classe: string }> = {
  alto: { texto: "🔴 Atraso provável", classe: "proto-pill-danger" },
  medio: { texto: "🟡 Atenção", classe: "proto-pill-warn" },
  ok: { texto: "🟢 Dentro do padrão", classe: "proto-pill-ok" },
};

/**
 * Protótipo da aposta 1: torre de controle preditiva de atraso. Sem lógica de
 * negócio nova - dados ilustrativos, mesmo padrão das outras 4 telas desta pasta.
 * O lead time esperado (8 dias) e o corte de risco vêm do Painel Executivo real
 * (KPI 01), que é a base de dados que sustentaria essa tela se for pra produção.
 */
const TorreControleView: React.FC = () => {
  const navItems: NavBarItem[] = [
    { label: "Início", route: "/", iconName: "house-door" },
    { label: "Iniciativas", route: "/iniciativas-estrategicas", iconName: "compass" },
  ];

  return (
    <Container fluid>
      <NavBar items={navItems} />
      <div className="mb-2"></div>

      <div className="proto-wrap">
        <Link to="/iniciativas-estrategicas" className="proto-back">← Iniciativas estratégicas</Link>

        <div className="proto-header">
          <div className="proto-badge">🧭 Protótipo — aposta 1 de 5</div>
          <h2>Torre de controle preditiva de atraso</h2>
          <p className="proto-subtitle">
            Compara o tempo que cada embarque já está em andamento com o lead time esperado da rota (hoje, 8,1
            dias em média — ver Painel Executivo) e sinaliza quem está se desviando do padrão, antes do cliente
            perguntar.
          </p>
        </div>

        <div className="proto-section-title">Embarques monitorados agora</div>
        <div className="proto-mock">
          <div className="proto-mock-bar">
            <div className="proto-mock-dot"></div><div className="proto-mock-dot"></div><div className="proto-mock-dot"></div>
            <span className="proto-mock-title">giantlog.giantcargo.com.br/torre-controle</span>
          </div>
          <div className="proto-mock-body" style={{ padding: 0 }}>
            <table className="proto-table">
              <thead>
                <tr>
                  <th>Referência</th>
                  <th>Cliente</th>
                  <th>Origem</th>
                  <th>Modal</th>
                  <th>Em andamento</th>
                  <th>Esperado</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {embarques.map((e) => (
                  <tr key={e.referencia}>
                    <td style={{ fontFamily: "var(--mono)" }}>{e.referencia}</td>
                    <td>{e.cliente}</td>
                    <td>{e.origem}</td>
                    <td>{e.modal}</td>
                    <td>{e.diasEmAndamento} dias</td>
                    <td>{e.leadTimeEsperado} dias</td>
                    <td><span className={`proto-pill ${riscoPill[e.risco].classe}`}>{riscoPill[e.risco].texto}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="proto-note">
          Dados ilustrativos. Se aprovado, o corte de risco usaria o histórico real por rota (armazém de origem +
          modal + transportador via CarrierInformation) em vez de um número fixo de dias.
        </div>

        <div className="proto-footer-nav">
          <Link to="/iniciativas-estrategicas">← Ver as 5 apostas</Link>
          <Link to="/iniciativas-estrategicas/portal-cliente">Próxima: Portal do cliente →</Link>
        </div>
      </div>
    </Container>
  );
};

export default TorreControleView;
